// extracted by mini-css-extract-plugin
export default {"div":"select_div__oiBen","select":"select_select__zNk3K","err":"select_err__rwLHr","label":"select_label__6mp7H"};